<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newUser"><!-- @click="newUser" -->
            <i class="el-icon-plus"></i>
            创建
          </el-button>
          <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input>
        </div>
        <el-table
          class="table-container"
          :data="tableData"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form class="expand-list">
                <el-form-item label="地址：">
                  <span>{{props.row.addr}}</span>
                </el-form-item>
                <el-form-item label="银行账号：">
                  <span>{{props.row.bank_account}}</span>
                </el-form-item>
              </el-form>
              <el-form class="expand-list">
                <el-form-item label="开户银行名称：">
                  <span>{{props.row.bank}}</span>
                </el-form-item>
                <el-form-item label="税号：">
                  <span>{{props.row.tax_no}}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            label="公司名"
            prop="company_name"></el-table-column>
          <el-table-column
            label="联系人"
            prop="contactor"></el-table-column>
          <el-table-column
            label="联系电话"
            prop="phone"></el-table-column>
          <el-table-column label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row)"
                >
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
              <el-button
                class="delete-btn"
                @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改的弹窗框 start -->
    <el-dialog
      title="修改客户信息"
      class="dialog-container"
      :visible.sync="dialogUpdate">
      <el-form class="form-container" :model="ruleAdd" ref="ruleAdd" :rules="rules"> <!-- :model="ruleAdd"  :rules="rules" ref="ruleAdd" -->
        <el-form-item class="input-list" label="业务人员" prop="sales_id" v-if="user_type == 5">
          <el-select class="options-select" v-model="sales_id" value-key="user_id" placeholder="请选择业务人员" clearable>
            <el-option
              v-for="item in sales"
              :key="item.user_id"
              :label="item.name"
              :value="item.user_id">
              {{item.name}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input-list" label="公司名称" prop="company_name">
          <el-input type="text" placeholder="请输入公司名称" v-model="ruleAdd.company_name"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="公司类型" prop="company_type">
          <el-select v-model="ruleAdd.is_vip" placeholder="请选择"> <!--   :value="ruleAdd.is_vip"-->
            <el-option
              v-for="item in company_type"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="ruleAdd.is_vip == 1">
          <el-form-item class="input-list" label="合同号" prop="contract_no">
          <el-input type="text" placeholder="请输入合同号" v-model="ruleAdd.contract_no"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="付费周期" prop="bill_cycle">
            <el-input type="text" placeholder="请输入付费周期" v-model="ruleAdd.bill_cycle"></el-input>
          </el-form-item>
        </template>
        <el-form-item class="input-list" label="联系人" prop="contactor">
          <el-input type="text" placeholder="请输入联系人的名称" v-model="ruleAdd.contactor"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="手机号" prop="phone">
          <el-input type="text" placeholder="请输入手机号" v-model="ruleAdd.phone"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="地址" prop="addr">
          <el-input type="text" placeholder="请输入地址" v-model="ruleAdd.addr"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="银行账号" prop="bank_account">
          <el-input type="text" placeholder="请输入银行账号" v-model="ruleAdd.bank_account"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="开户银行" prop="bank">
          <el-input type="text" placeholder="请输入开户银行名称" v-model="ruleAdd.bank"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="税号" prop="tax_no">
          <el-input type="text" placeholder="请输入税号" v-model="ruleAdd.tax_no"></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button class="btn-save" @click="submitForm('ruleAdd')">保存</el-button>
        </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 修改弹窗框 end -->
    <!-- 创建的弹窗框 start -->
    <el-dialog
      title="新建客户客户信息"
      class="dialog-container"
      :visible.sync="dialogNew">
      <el-form class="form-container" :model="ruleNew" ref="ruleNew" :rules="rules">
        <el-form-item class="input-list" label="业务人员" prop="sales_id" v-if="user_type == 5">
          <el-select class="options-select" v-model="sales_id" value-key="user_id" placeholder="请选择业务人员" clearable>
            <el-option
              v-for="item in sales"
              :key="item.user_id"
              :label="item.name"
              :value="item.user_id">
              {{item.name}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="input-list" label="公司名称" prop="company_name">
          <el-input type="text" placeholder="请输入公司名称" v-model="ruleNew.company_name"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="公司类型" prop="company_type">
          <el-select v-model="ruleNew.is_vip" placeholder="请选择"><!-- :value="ruleNew.is_vip" -->
            <el-option
              v-for="item in company_type"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="ruleNew.is_vip == 1">
          <el-form-item class="input-list" label="合同号" prop="contract_no">
          <el-input type="text" placeholder="请输入合同号" v-model="ruleNew.contract_no"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="付费周期" prop="bill_cycle">
            <el-input type="text" placeholder="请输入付费周期" v-model="ruleNew.bill_cycle"></el-input>
          </el-form-item>
        </template>
        <el-form-item class="input-list" label="联系人" prop="contactor">
          <el-input type="text" placeholder="请输入联系人的名称" v-model="ruleNew.contactor"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="手机号" prop="phone">
          <el-input type="text" placeholder="请输入手机号" v-model="ruleNew.phone"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="地址" prop="addr">
          <el-input type="text" placeholder="请输入地址" v-model="ruleNew.addr"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="银行账号" prop="bank_account">
          <el-input type="text" placeholder="请输入银行账号" v-model="ruleNew.bank_account"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="开户银行" prop="bank">
          <el-input type="text" placeholder="请输入开户银行名称" v-model="ruleNew.bank"></el-input>
        </el-form-item>
        <el-form-item class="input-list" label="税号" prop="tax_no">
          <el-input type="text" placeholder="请输入税号" v-model="ruleNew.tax_no"></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button class="btn-save" @click="addNew('ruleNew')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 创建的弹窗框 end -->
    <!-- 删除的弹窗框 start -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <!-- 删除的弹出框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
import DeleteBox from 'components/DeleteBox.vue'
import { companyName, tel } from 'common/js/loginValidate'
import { getStore, getCookie } from 'common/js/mUtils.js'
export default {
  data () {
    return {
      user_type: 0,
      user_id: 0,
      tableData: [],
      total: 0,
      page: 1,
      limit: 10,
      search_name: '',
      deleteIndex: 0, // 删除数据的INdex
      deleteRow: {}, // 删除的信息
      deleteShow: false, // 弹窗框的显示
      dialogUpdate: false, // 修改弹窗框
      dialogNew: false,
      ruleAdd: {
        company_name: '', // 公司名字
        addr: '', //公司地址
        bank: '', // 开户银行的名称
        bank_account: '', // 银行账号
        contactor: '', // 联系人姓名
        customer_id: '', // 客户ID
        phone: '', // 手机号码
        tax_no: '' // 税号
      },
      ruleNew: {
        company_name: '', // 公司名字
        addr: '', //公司地址
        bank: '', // 开户银行的名称
        bank_account: '', // 银行账号
        contactor: '', // 联系人姓名
        phone: '', // 手机号码
        tax_no: '', // 税号，
        is_vip: 0,
        contract_no: '',
        bill_cycle: ''
      },
      rules: {
        company_name: [
          { validator: companyName, trigger: ['blur'] }
        ],
        phone: [
          { validator: tel, trigger: ['blur'] }
        ]
      },
      sales:[],
      sales_id: null,
      empty: '没有客户信息列表',
      search_show: false,
      company_type: [{
        value: 0,
        label: '普通客户'
      },{
        value: 1,
        label: '合同客户'
      }]
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.user_type = getStore('user_type')
    this.user_id = getCookie('u_uuid_userId')
    this.initData()
    this.getAllSalesman()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8;'
      } else {
        return ''
      }
    },
    initData () { // 初始化数据
      let that = this
      // 获取客户信息
      this.$api.customerDetail({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    getAllSalesman() {
      let that = this
      this.$api.getAllSalesman({
        type: 1
      }).then(
        res => {
          if (res.data.length > 0) {
            that.sales = res.data
          } else {
            that.sales = []
            that.$message({
              message: '没有市场人员信息，请添加。',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }
      ).catch(e => {
        that.$message({
          message: `${e}`,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    searchName () { // 输入名字删除
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        this.$api.searchCustomer({
          name: that.search_name,
          page_num: (that.page - 1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '搜索不能为空！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    handleDelete (index,row) { // 点击删除按钮
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.customer_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },
    delete (index, customer_id) { // 点击确认删除
      let that = this
      this.$api.deleteCustomer({
        customer_id: customer_id
      }).then(res => {
        if (res.data.msg === true) {
          /* that.tableData.splice(index, 1)
          that.total = that.total - 1 */
          that.initData()
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleEdit (row) { // 点击修改
      this.dialogUpdate = true
      this.ruleAdd = {...row, is_vip: Number(row.is_vip)}
      if (this.user_id == row.lab_user_id) {
        this.sales_id = null
      } else {
        this.sales_id = row.lab_user_id
      }
    },
    submitForm(formName) { // 修改后 点击保存
      let that = this
      if (that.ruleAdd.is_vip == 1) {
        if (!(that.ruleAdd.contract_no && that.ruleAdd.bill_cycle)) {
          that.$message({
            type: 'error',
            message: '合同客户的合同号和付费周期必填项',
            customClass: 'msg-position',
            showClose: true
          })
          return
        }
      }
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.updateCustomer({
            ...that.ruleAdd,
            sales_id: that.sales_id
          }).then(res => {
            that.dialogUpdate = false
            if (res.data.msg === true) {
              that.$message({
                type: 'success',
                message: '客户信息保存成功！！',
                customClass: 'msg-position',
                showClose: true
              })
              if (that.search_show) {
                that.searchName()
              } else {
                that.initData()
              }
            } else {
              that.$message({
                type: 'error',
                message: '修改信息失败！！',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(err => {
            that.$message({
              type: 'error',
              message: err,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    newUser () { // 点击 创建按钮
      this.sales_id = null,
      this.ruleNew = {
        company_name: '', // 公司名字
        addr: '', //公司地址
        bank: '', // 开户银行的名称
        bank_account: '', // 银行账号
        contactor: '', // 联系人姓名
        phone: '', // 手机号码
        tax_no: '', // 税号
        is_vip: 0,
        contract_no: '',
        bill_cycle: ''
      }
      this.dialogNew = true
    },
    addNew (formName) { // 修改后 点击保存
      let that = this
      if (that.ruleNew.is_vip == 1) {
        if (!(that.ruleNew.contract_no && that.ruleNew.bill_cycle)) {
          that.$message({
            type: 'error',
            message: '合同客户的合同号和付费周期必填项',
            customClass: 'msg-position',
            showClose: true
          })
          return
        }
      }
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.addCustomer({
            ...that.ruleNew,
            sales_id: that.sales_id
          }).then(res => {
            that.dialogNew = false
            if (res.data.msg === true) {
              that.$message({
                type: 'success',
                message: '新建客户成功！！',
                customClass: 'msg-position',
                showClose: true
              })
              that.initData()
            } else {
              that.$message({
                type: 'error',
                message: '新建客户信息失败！！',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(err => {
            that.$message({
              type: 'error',
              message: err,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    }
  },
  watch: {
  },
  components: {
    DeleteBox
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
@import '~common/stylus/box.styl'
</style>
